import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to dynamically set the page title based on the current route
 * - CRM pages (/app/*): "AustnewsCRM"
 * - Public pages: "Austnews"
 */
const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if the current path is a CRM route (starts with /app)
    const isCRMRoute = location.pathname.startsWith('/app');
    
    // Set the appropriate title
    if (isCRMRoute) {
      document.title = 'AustnewsCRM';
    } else if (location.pathname.startsWith('/epublisher-kb')) {
      // The knowledge base sets its own per-article title (see EPublisherKB.js)
    } else {
      document.title = 'Austnews';
    }
  }, [location.pathname]);
};

export default usePageTitle;

